// KitchenManagement.jsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faAppleAlt, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import ProductsList from './ProductsList';
import DishesList from './DishesList';
import NutritionNormsList from './NutritionNormsList';
import '../../../kindergartens/detail/components/QueueFull/cabinet-zdo-requests.css';
import './kitchen-management.css';

const KitchenManagement = () => {
  const [activeTab, setActiveTab] = useState('products');

  const tabs = [
    { id: 'products', label: 'Продукти', icon: faAppleAlt, referenceType: 'products' },
    { id: 'dishes', label: 'Блюда', icon: faUtensils, referenceType: 'dishes' },
    { id: 'nutrition-norms', label: 'Норми харчування', icon: faBalanceScale, referenceType: 'nutrition-norms' }
  ];

  const currentTab = tabs.find(tab => tab.id === activeTab);

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          {/* Панель табов */}
          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Управління харчуванням</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                {tabs.map((tab) => (
                  <li key={tab.id} className="nav-item">
                    <button
                      className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <FontAwesomeIcon icon={tab.icon} className="me-2" />
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Контент вкладок */}
          <div className="kitchen-content">
            {activeTab === 'products' && <ProductsList referenceType="products" />}
            {activeTab === 'dishes' && <DishesList referenceType="dishes" />}
            {activeTab === 'nutrition-norms' && <NutritionNormsList referenceType="nutrition-norms" />}
          </div>
        </div>
      </div>
    </main>
  );
};

export default KitchenManagement;